"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _inputModule = _interopRequireDefault(require("./input.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Input = /*#__PURE__*/function (_PureComponent) {
  function Input() {
    _classCallCheck(this, Input);
    return _callSuper(this, Input, arguments);
  }
  _inherits(Input, _PureComponent);
  return _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        id = _this$props.id,
        type = _this$props.type,
        className = _this$props.className,
        name = _this$props.name,
        value = _this$props.value,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        placeholder = _this$props.placeholder,
        maxLength = _this$props.maxLength,
        autoFocus = _this$props.autoFocus,
        autoComplete = _this$props.autoComplete,
        readOnly = _this$props.readOnly,
        ariaLabel = _this$props.ariaLabel,
        ariaInvalid = _this$props.ariaInvalid,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        disabled = _this$props.disabled,
        required = _this$props.required,
        defaultValue = _this$props.defaultValue,
        extensionProps = _this$props.extensionProps;
      var valueProp = defaultValue !== undefined ? {
        defaultValue: defaultValue
      } : {
        value: value
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread(_objectSpread({
        id: id,
        type: type,
        className: (0, _classnames["default"])(_inputModule["default"]['c-input'], className),
        name: name
      }, valueProp), {}, {
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        placeholder: placeholder,
        maxLength: maxLength,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        autoComplete: autoComplete,
        readOnly: readOnly,
        "aria-label": ariaLabel,
        "aria-invalid": ariaInvalid,
        "aria-describedby": ariaDescribedBy,
        disabled: disabled,
        required: required,
        ref: function ref(el) {
          _this.input = el;
        }
      }, extensionProps), {}, {
        "data-testid": "input",
        "data-jlds": true
      }));
    }
  }]);
}(_react.PureComponent);
_defineProperty(Input, "propTypes", {
  /** Required: the unique id of the checkbox input */
  id: _propTypes["default"].string.isRequired,
  /** The input element's type */
  type: _propTypes["default"].string,
  /** Custom class name to be applied */
  className: _propTypes["default"].string,
  /** The name of the input element */
  name: _propTypes["default"].string.isRequired,
  /** The value of the input (if applicable) */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** The defaultValue of the input (if applicable) */
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** Function to be called when a change event is fired by the input */
  onChange: _propTypes["default"].func,
  /** Function to be called when the input accepts focus */
  onFocus: _propTypes["default"].func,
  /** Function to be called when the input loses focus */
  onBlur: _propTypes["default"].func,
  /** Placeholder text to appear if input is empty */
  placeholder: _propTypes["default"].string,
  /** Set maximum number of characters to be accepted */
  maxLength: _propTypes["default"].number,
  /** Focus on this input when the page loads */
  autoFocus: _propTypes["default"].bool,
  /**  */
  autoComplete: _propTypes["default"].string,
  /** Mark the textarea as readonly so it can't be edited */
  readOnly: _propTypes["default"].bool,
  /** Set the aria-label attribute */
  ariaLabel: _propTypes["default"].string,
  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes["default"].string,
  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes["default"].string,
  /** Disable the textarea element */
  disabled: _propTypes["default"].bool,
  /** Mark the input element as a required field */
  required: _propTypes["default"].bool,
  /**  */
  extensionProps: _propTypes["default"].objectOf(_propTypes["default"].any)
});
_defineProperty(Input, "defaultProps", {
  className: undefined,
  type: 'text',
  //
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  //
  placeholder: undefined,
  maxLength: null,
  autoFocus: false,
  autoComplete: 'on',
  readOnly: false,
  ariaLabel: undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  disabled: false,
  required: false,
  defaultValue: undefined,
  //
  extensionProps: {}
});
var _default = exports["default"] = Input;